module.exports = __webpack_public_path__ + "static/media/escapesql.12c2e253.svg";